import { IdTokenResult } from "firebase/auth";

/**
 * Email that is always treated as an admin. This mirrors the hardcoded
 * super-admin in the Cloud Functions (functions/src/index.ts) so the client
 * can reach the admin UI to bootstrap the very first admin on the live site.
 */
export const SUPERADMIN_EMAIL = "aumkar.inamdar@notatia.org";

/** Roles that can be granted from the admin UI. */
export const AVAILABLE_ROLES = ["admin"] as const;
export type AppRole = (typeof AVAILABLE_ROLES)[number];

/**
 * Reads the `roles` custom claim off a Firebase ID token result, tolerating
 * the common case where the claim is absent (non-admin users). Returns an
 * empty array rather than throwing.
 */
export function getRoles(
    tokenResult: IdTokenResult | undefined | null
): string[] {
    const roles = tokenResult?.claims?.roles;
    return Array.isArray(roles) ? (roles as string[]) : [];
}

/**
 * True when the signed-in user carries the `admin` role claim, or is the
 * hardcoded super-admin (whose claim may not be set yet on first sign-in).
 */
export function isAdmin(
    tokenResult: IdTokenResult | undefined | null
): boolean {
    if (!tokenResult) return false;
    const email = tokenResult.claims?.email;
    if (
        typeof email === "string" &&
        email.toLowerCase() === SUPERADMIN_EMAIL
    ) {
        return true;
    }
    return getRoles(tokenResult).includes("admin");
}
